/**
 * TD Marquee Slider Component
 * Pure JavaScript implementation for infinite scrolling marquee
 */

class TdMarqueeSlider {
  constructor(element, options = {}) {
    this.element = element;
    this.container = element.querySelector('.td-marquee-container');
    this.track = element.querySelector('.td-marquee-track');
    
    if (!this.container || !this.track) {
      console.warn('TD Marquee: Required elements not found');
      return;
    }

    this.options = {
      speed: options.speed || 20,
      pauseOnHover: options.pauseOnHover !== undefined ? options.pauseOnHover : false,
      direction: options.direction || 'left',
      ...options
    };

    this.init();
  }

  init() {
    // Clone the track multiple times for seamless loop
    this.cloneTracks();
    
    // Set animation speed
    this.setSpeed(this.options.speed);
    
    // Setup pause on hover
    if (this.options.pauseOnHover) {
      this.setupHoverPause();
    }

    // Setup direction
    if (this.options.direction === 'right') {
      this.container.style.animationDirection = 'reverse';
    }
  }

  cloneTracks() {
    // Clone the track multiple times to ensure seamless infinite scroll
    // Create at least 3 copies to fill the viewport
    const numberOfClones = 3;
    
    for (let i = 0; i < numberOfClones; i++) {
      const clone = this.track.cloneNode(true);
      this.container.appendChild(clone);
    }
  }

  setSpeed(seconds) {
    this.container.style.setProperty('--td-marquee-speed', `${seconds}s`);
  }

  setupHoverPause() {
    this.element.addEventListener('mouseenter', () => {
      this.container.classList.add('paused');
    });

    this.element.addEventListener('mouseleave', () => {
      this.container.classList.remove('paused');
    });
  }

  pause() {
    this.container.classList.add('paused');
  }

  play() {
    this.container.classList.remove('paused');
  }

  destroy() {
    // Remove cloned tracks
    const tracks = this.container.querySelectorAll('.td-marquee-track');
    // Keep only the first track, remove all clones
    for (let i = 1; i < tracks.length; i++) {
      tracks[i].remove();
    }
  }
}

// Auto-initialize td-marquee sections
if (!customElements.get('td-marquee-slider')) {
  customElements.define('td-marquee-slider', class extends HTMLElement {
    connectedCallback() {
      const speed = parseFloat(this.getAttribute('data-speed')) || 20;
      const pauseOnHover = this.getAttribute('data-pause-hover') === 'true';
      const direction = this.getAttribute('data-direction') || 'left';

      this.marquee = new TdMarqueeSlider(this, {
        speed,
        pauseOnHover,
        direction
      });
    }

    disconnectedCallback() {
      if (this.marquee) {
        this.marquee.destroy();
      }
    }
  });
}

// Export for external use
window.TdMarqueeSlider = TdMarqueeSlider;

